import { getAPI, postAPI } from "utils/http";
import constants from "../../constants/constants.json";
import { apis } from "config/urls";

export function sortCards({ data, sortOption }) {
  if (!data?.length) return [];
  switch (sortOption) {
    case constants.sortDesc:
      return data.sort((a, b) => b.product_name.localeCompare(a.product_name));
    case constants.sortByFavorites: {
      const ascSort = data.sort((a, b) =>
        a.product_name.localeCompare(b.product_name)
      );
      return ascSort.sort((a, b) => b.isFavorated - a.isFavorated);
    }
    default:
      return data.sort((a, b) => a.product_name.localeCompare(b.product_name));
  }
}

export async function getOverviewLevel1({ token }) {
  const params = {
    op_code: "get_product_details",
    time_start: "2021-01-01 00:00:00",
    time_end: "2021-03-01 00:00:00",
    offset: 0,
    count: 9,
  };
  return await getAPI(apis.GWAPI, params, token);
}

export async function userFavorites({ token, payload }) {
  const params = {
    op_code: payload.action,
    user_id: payload.userId,
    product_id: payload.productId,
  };
  return await postAPI(apis.GWAPI, params, token);
}
